import './Home.css';

const Home = () => {
  return (
    <div>

      <div className="home-header">
        <h1>Adarsh Singh</h1>
        <h2 className="home-subtitle">Bengaluru, Karnataka 560078</h2>
      </div>

      <hr />
      <div className="home-contact">
        <span>📞 <a href="tel:+919821710137">+91 9821710137</a></span>
        <span>✉️ <a href="mailto:sadarsh460@gmail.com">sadarsh460@gmail.com</a></span>
        <span>🌐 <a href="https://linkedin.com/in/scoder17">linkedin/scoder17</a></span>
        <span>🌐 <a href="https://github.com/scoder17">github/scoder17</a></span>
      </div>
      <hr />

      <div className="home-body">
        <h2><u>Education</u></h2>
        <h3>Dayananda Sagar College of Engineering, Bengaluru</h3>
        <p><i>Bachelor of Engineering in Computer Science</i></p>
        <p>Dec. 2021 – Jun. 2025 | CGPA: 9.67</p>

        <h2><u>Experience</u></h2>
        <ul>
          <li>
            <strong>AutoRABIT — Junior Site Reliability Engineer (Sept. 2025 – Present, On-site)</strong>
            <ul>
              <li>Working with various tools and technologies across the SRE tech stack.</li>
              <li>Built end-to-end Terraform infrastructure (12+ modules) enabling fully automated, scalable environment provisioning.</li>
              <li>Designed and implemented CI/CD pipelines, improving release reliability and reducing manual deployment effort.</li>
              <li>Manage 15+ AWS services (VPC, EC2, S3, RDS, IAM, EKS, ECS, WAF, SQS, EventBridge, EFS, Inspector, etc.) to ensure high availability and security.</li>
              <li>Enhancing monitoring and observability using the ELK Stack.</li>
            </ul>
          </li>
          <br />
          <li>
            <strong>Pluralsight — DevOps Intern (Jan. 2025 – Jun. 2025, On-site)</strong>
            <ul>
              <li>Created Terraform modules to automate Grafana dashboard setup and alert configuration.</li>
              <li>Implemented Terraform check blocks to enforce AWS best practices and compliance standards.</li>
              <li>Explored DevSecOps to integrate security tools into CI/CD pipelines.</li>
            </ul>
          </li>
          <br />
          <li>
            <strong>Visist.ai — SDE Intern (Apr. 2024 – Jul. 2024, On-site)</strong>
            <ul>
              <li>Worked on BLE-based and video-capturing applications.</li>
              <li>Built Android and Flutter apps using MVVM/MVC architecture, reducing app load time by 30%.</li>
              <li>Designed APIs and optimized MongoDB queries.</li>
            </ul>
          </li>
          <br />
          <li>
            <strong>IIT Bhilai — Research Intern (Sept. 2023 – Mar. 2024, On-site)</strong>
            <ul>
              <li>Built Android app using Jetpack Compose.</li>
              <li>Researched credit scoring and microfinance systems, improving ML model accuracy by 10%.</li>
              <li>Analyzed data for AI models and wrote literature reviews.</li>
            </ul>
          </li>
          <br />
          <li>
            <strong>NTT Data — Software Engineer Intern (Feb. 2023 – Mar. 2023, Hybrid)</strong>
            <ul>
              <li>Developed the front end using ReactJS and the back end using Django and REST APIs.</li>
              <li>Used PostgreSQL to improve performance and data consistency.</li>
              <li>Collaborated using Git and JIRA.</li>
            </ul>
          </li>
        </ul>

        <h2><u>Projects</u></h2>
        <ul>
          <li>
            <strong>WebApp Deployment using AWS CI/CD </strong>
            (<a href="https://github.com/scoder17/webapp-deploy-aws">GitHub</a>)
            <ul>
              <li>Provisioned cloud infrastructure using Infrastructure-as-Code principles (idempotent Terraform modules).</li>
              <li>Built CI/CD pipeline (CodePipeline + CodeBuild + CodeDeploy) deploying containerized Flask service to Auto Scaling Group behind ALB.</li>
              <li>Implemented health-check-based rollouts, automated rollback mechanisms, and CloudWatch observability, reducing deployment-related incidents by 90%.</li>
            </ul>
          </li>
          <br />
          <li>
            <strong>Cloud Infra Automation – AWS & Terraform </strong>
            (<a href="https://github.com/scoder17/aws-cloud-infra">GitHub</a>)
            <ul>
              <li>Automated AWS setup with Terraform.</li>
              <li>Includes VPC, EC2, S3, subnets, NAT, etc.</li>
              <li>CI/CD via GitHub Actions.</li>
            </ul>
          </li>
        </ul>

        <h2><u>Technical Skills</u></h2>
        <ul>
          <li><strong>Systems:</strong> Linux, Networking Fundamentals, OS Internals</li>
          <li><strong>Cloud & Distributed Systems:</strong> AWS (EKS, ECS, EC2, S3, WAF, Inspector, etc.), Terraform, Docker, Kubernetes</li>
          <li><strong>Observability:</strong> ELK Stack, Grafana, CloudWatch</li>
          <li><strong>CI/CD & Automation:</strong> GitHub Actions, GitLab CI/CD, AWS CI/CD, Shell Scripting, Python scripting</li>
          <li><strong>Languages:</strong> C, C++, Java, Kotlin, Python, Dart, HTML, CSS, JavaScript, SQL</li>
          <li><strong>Databases:</strong> MySQL, PostgreSQL, MongoDB, Firebase</li>
        </ul>

        <h2><u>Extra</u></h2>
        <ul>
          <li>GATE DA 2025 Qualified, secured AIR 8,314 out of 57,054 candidates.</li>
          <li>GATE CS 2024 Qualified, secured AIR 12,708 out of 1,23,967 candidates.</li>
          <li>Won the Best Innovative Project Award at Project Open Day 2024, organized at DSCE.</li>
          <li>Solved 450+ problems on <a href="https://leetcode.com/u/scoder17/">Leetcode</a>.</li>
          <li>AIR 10 – National Creativity Olympiad 2018.</li>
        </ul>
      </div>

    </div>
  );
};

export default Home;